export default {
  "hierarchy": {
    "rowS": [
      "flex-rowS"
    ],
    "rowM": [
      "flex-rowM"
    ],
    "rowSpaceBetween": [
      "flex-rowSpaceBetween"
    ],
    "rowMEnd": [
      "flex-rowM",
      "flex-rowMEnd"
    ],
    "col": [
      "flex-col"
    ],
    "colS": [
      "flex-col",
      "flex-colS"
    ],
    "colM": [
      "flex-col",
      "flex-colM"
    ],
    "colL": [
      "flex-col",
      "flex-colL"
    ],
    "colXL": [
      "flex-col",
      "flex-colXL"
    ],
    "colXXL": [
      "flex-col",
      "flex-colXXL"
    ],
    "dialogButtons": [
      "flex-rowM",
      "flex-rowMEnd",
      "flex-dialogButtons"
    ],
    "hNavBar": [
      "flex-hNavBar"
    ],
    "vNavBar": [
      "flex-vNavBar"
    ],
    "itemBar": [
      "flex-itemBar"
    ],
    "screenTitle": [
      "flex-screenTitle"
    ],
    "screenTitleControls": [
      "flex-screenTitleControls"
    ],
    "topNavBar": [
      "flex-topNavBar"
    ],
    "topNavControls": [
      "flex-topNavControls"
    ],
    "sideNav": [
      "flex-sideNav"
    ],
    "loadingScreen": [
      "flex-loadingScreen"
    ],
    "tableToolbar": [
      "flex-tableToolbar"
    ],
    "rowL": [
      "flex-rowL"
    ],
    "dialogTitle": [
      "flex-screenTitle",
      "flex-dialogTitle"
    ],
    "dialogTitleControls": [
      "flex-screenTitleControls",
      "flex-dialogTitleControls"
    ],
    "tableHeader": [
      "flex-rowM",
      "flex-tableHeader"
    ],
    "aggBucketVertical": [
      "flex-aggBucketVertical"
    ],
    "aggBucketHorizontal": [
      "flex-aggBucketHorizontal"
    ],
    "mobileMainHeaderControls": [
      "flex-screenTitleControls",
      "flex-mobileMainHeaderControls"
    ],
    "colSpaceBetween": [
      "flex-colSpaceBetween"
    ],
    "rowMCenter": [
      "flex-rowM",
      "flex-rowMCenter"
    ],
    "colMCenter": [
      "flex-col",
      "flex-colM",
      "flex-colMCenter"
    ],
    "aggregationBucketFlexHorizontal": [
      "flex-aggBucketHorizontal",
      "flex-aggregationBucketFlexHorizontal"
    ],
    "colSCenter": [
      "flex-col",
      "flex-colS",
      "flex-colSCenter"
    ],
    "colMStart": [
      "flex-col",
      "flex-colM",
      "flex-colMStart"
    ],
    "colSStart": [
      "flex-col",
      "flex-colS",
      "flex-colSStart"
    ],
    "rowMMiddle": [
      "flex-rowM",
      "flex-rowMCenter",
      "flex-rowMMiddle"
    ],
    "mobileNavRoutes": [
      "flex-col",
      "flex-colM",
      "flex-mobileNavRoutes"
    ],
    "sideNavBarCollapse": [
      "flex-sideNavBarCollapse"
    ],
    "footerItemBar": [
      "flex-itemBar",
      "flex-footerItemBar"
    ],
    "layoutActionBar": [
      "flex-layoutActionBar"
    ],
    "center": [
      "flex-center"
    ],
    "aggregationsContainerToolbar": [
      "flex-tableToolbar",
      "flex-aggregationsContainerToolbar"
    ],
    "mobileOptNavTitle": [
      "flex-mobileOptNavTitle"
    ],
    "mobileOptNavTitleControls": [
      "flex-mobileOptNavTitleControls"
    ],
    "sidenavbarcollapse": [
      "flex-sidenavbarcollapse"
    ],
    "pairDetail": [
      "flex-pairDetail"
    ],
    "bulkCreateResults": [
      "flex-bulkCreateResults"
    ],
    "rowXXL": [
      "flex-rowXXL"
    ],
    "rowMStart": [
      "flex-rowM",
      "flex-rowMStart"
    ],
    "sideNavControls": [
      "flex-sideNavControls"
    ],
    "rowSpaceBetweenCenter": [
      "flex-rowSpaceBetween",
      "flex-rowSpaceBetweenCenter"
    ],
    "rowSpaceAround": [
      "flex-rowSpaceAround"
    ],
    "rowStretch": [
      "flex-rowStretch"
    ],
    "sortFilterBar": [
      "flex-sortFilterBar"
    ],
    "preConditionBar": [
      "flex-preConditionBar"
    ],
    "filterBar": [
      "flex-filterBar"
    ],
    "conditionRow": [
      "flex-conditionRow"
    ],
    "conditionRowEmpty": [
      "flex-conditionRowEmpty"
    ],
    "actionBarDashboard": [
      "__root__",
      "flex-actionBarDashboard"
    ],
    "bulkCreateMapFieldsEntry": [
      "flex-rowM",
      "flex-bulkCreateMapFieldsEntry"
    ],
    "rowMEndCenter": [
      "flex-rowM",
      "flex-rowMEnd",
      "flex-rowMEndCenter"
    ],
    "pairTitleControls": [
      "flex-pairTitleControls"
    ],
    "rowSWrap": [
      "flex-rowS",
      "flex-rowSWrap"
    ],
    "rowSWrapEnd": [
      "flex-rowS",
      "flex-rowSWrap",
      "flex-rowSWrapEnd"
    ],
    "rowSCenter": [
      "flex-rowS",
      "flex-rowSCenter"
    ],
    "rowMTop": [
      "flex-rowM",
      "flex-rowMTop"
    ],
    "rowXL": [
      "flex-rowL",
      "flex-rowXL"
    ],
    "colLCenter": [
      "flex-col",
      "flex-colL",
      "flex-colLCenter"
    ],
    "altLoginMethods": [
      "flex-altLoginMethods"
    ],
    "rowEnd": [
      "flex-rowEnd"
    ],
    "loginPane": [
      "flex-loginPane"
    ],
    "colCenter": [
      "flex-col",
      "flex-colCenter"
    ],
    "colMCenterMiddle": [
      "flex-col",
      "flex-colM",
      "flex-colMCenter",
      "flex-colMCenterMiddle"
    ],
    "colLCenterMiddle": [
      "flex-col",
      "flex-colL",
      "flex-colLCenter",
      "flex-colLCenterMiddle"
    ],
    "colCenterMiddle": [
      "flex-col",
      "flex-colCenter",
      "flex-colCenterMiddle"
    ],
    "colLStart": [
      "flex-col",
      "flex-colM",
      "flex-colMStart",
      "flex-colLStart"
    ],
    "colCenterStretch": [
      "flex-col",
      "flex-colCenter",
      "flex-colCenterStretch"
    ],
    "rsrcToolbar": [
      "flex-tableToolbar",
      "flex-rsrcToolbar"
    ],
    "aggregationBucketFlex": [
      "flex-aggregationBucketFlex"
    ],
    "aggregationContainerFlex": [
      "flex-aggregationContainerFlex"
    ],
    "rowSReverse": [
      "flex-rowS",
      "flex-rowSReverse"
    ],
    "toast": [
      "flex-toast"
    ],
    "header": [
      "flex-header"
    ],
    "collection": [
      "flex-collection"
    ],
    "projectButton": [
      "flex-projectButton"
    ],
    "actionBarHorizontal": [
      "flex-actionBarHorizontal"
    ],
    "conditionRowFlex": [
      "flex-conditionRowFlex"
    ]
  },
  "props": {
    "default": {},
    "rowS": {},
    "rowM": {},
    "rowSpaceBetween": {},
    "rowMEnd": {},
    "col": {},
    "colS": {},
    "colM": {},
    "colL": {},
    "colXL": {},
    "colXXL": {},
    "dialogButtons": {},
    "hNavBar": {},
    "vNavBar": {},
    "itemBar": {},
    "screenTitle": {},
    "screenTitleControls": {},
    "topNavBar": {},
    "topNavControls": {},
    "sideNav": {},
    "loadingScreen": {},
    "tableToolbar": {},
    "rowL": {},
    "dialogTitle": {},
    "dialogTitleControls": {},
    "tableHeader": {},
    "aggBucketVertical": {},
    "aggBucketHorizontal": {},
    "mobileMainHeaderControls": {},
    "colSpaceBetween": {},
    "rowMCenter": {},
    "colMCenter": {},
    "aggregationBucketFlexHorizontal": {},
    "colSCenter": {},
    "colMStart": {},
    "colSStart": {},
    "rowMMiddle": {},
    "mobileNavRoutes": {},
    "sideNavBarCollapse": {},
    "footerItemBar": {},
    "layoutActionBar": {},
    "center": {},
    "aggregationsContainerToolbar": {},
    "mobileOptNavTitle": {},
    "mobileOptNavTitleControls": {},
    "sidenavbarcollapse": {},
    "pairDetail": {},
    "bulkCreateResults": {},
    "rowXXL": {},
    "rowMStart": {},
    "sideNavControls": {},
    "rowSpaceBetweenCenter": {},
    "rowSpaceAround": {},
    "rowStretch": {},
    "sortFilterBar": {},
    "preConditionBar": {},
    "filterBar": {},
    "conditionRow": {},
    "conditionRowEmpty": {},
    "actionBarDashboard": {},
    "bulkCreateMapFieldsEntry": {},
    "rowMEndCenter": {},
    "pairTitleControls": {},
    "rowSWrap": {},
    "rowSWrapEnd": {},
    "rowSCenter": {},
    "rowMTop": {},
    "rowXL": {},
    "colLCenter": {},
    "altLoginMethods": {},
    "rowEnd": {},
    "loginPane": {},
    "colCenter": {},
    "colMCenterMiddle": {},
    "colLCenterMiddle": {},
    "colCenterMiddle": {},
    "colLStart": {},
    "colCenterStretch": {},
    "rsrcToolbar": {},
    "aggregationBucketFlex": {},
    "aggregationContainerFlex": {},
    "rowSReverse": {},
    "toast": {},
    "header": {},
    "collection": {},
    "projectButton": {},
    "actionBarHorizontal": {},
    "conditionRowFlex": {}
  }
}